export enum ChoferEstado {
    AVAILABLE = 'Disponible',
    EXCEEDED = 'Excedido',
    EXCEEDED_WHIT_EXTENSION = 'Excedido con extensión',
    NOT_AVAILABLE = 'No disponible',
    ON_BREAK = 'En break'
}

export function driverStates() {
    return Object.values(ChoferEstado).sort();
}

/**
 * Clases Tailwind completas (p. ej. `text-gold`). No concatenar `text-` + nombre en JSX:
 * el JIT de Tailwind no ve clases armadas en runtime y no las incluye en el CSS.
 */
// Cada clase incluye su variante `dark:` "flúor" (más brillante) para
// conservar contraste sobre el fondo navy del tema oscuro — ver tokens
// `status` en `shared/theme/colorTokens.js` (design-system-proposal, sec. 2).
const AVAILABLE_TEXT_CLASS_BY_VEHICLE: Record<string, string> = {
    ejecutivo: 'text-green-500 dark:text-success-dark',
    utilitario: 'text-black-900 dark:text-ink-dark',
    vip: 'text-gold dark:text-yellow-300',
    minivan: 'text-purple-500 dark:text-purple-300',
    flete: 'text-black-900 dark:text-ink-dark',
    'minibus 19': 'text-purple-500 dark:text-purple-300',
    'minibus 24': 'text-purple-500 dark:text-purple-300',
    'minibus 15': 'text-purple-500 dark:text-purple-300',
    'bus +40': 'text-purple-500 dark:text-purple-300'
};

export function driverStateTextClass(
    state: string,
    vehicleType?: string
): string {
    switch (state) {
        case ChoferEstado.AVAILABLE:
        case ChoferEstado.EXCEEDED_WHIT_EXTENSION: {
            if (!vehicleType?.trim()) {
                return 'text-green-500 dark:text-success-dark';
            }
            const key = vehicleType.trim().toLowerCase();
            return (
                AVAILABLE_TEXT_CLASS_BY_VEHICLE[key] ??
                'text-green-500 dark:text-success-dark'
            );
        }
        case ChoferEstado.NOT_AVAILABLE:
            return 'text-red-500 dark:text-danger-dark';
        case ChoferEstado.ON_BREAK:
            return 'text-orange-500 dark:text-warning-dark';
        default:
            return 'text-blue-500 dark:text-info-dark';
    }
}
